import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function ContractMenu(props) {
  return (
    <Dropdown
      menuKey="contract"
      menu={projectMenus.contract}
      {...props}
    />
  );
}
